import '../App.css';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import AgenticWorkflow from '../components/AgenticWorkflow';
import CapabilitiesGrid from '../components/home/CapabilitiesGrid';
import FeaturedIntegrations from '../components/home/FeaturedIntegrations';
import StatsBar from '../components/home/StatsBar';
import FinalCTA from '../components/home/FinalCTA';

export const HomePage = ({ config }) => {
  return (
    <div className="text-white">
      <Helmet>
        <title>Katbot – Your AI Edge on Hyperliquid</title>
        <meta name="description" content="Agentic AI trading intelligence for leveraged perpetuals on Hyperliquid. Research, recommend, execute — with you in control." />
        <link rel="canonical" href="https://katbot.ai/" />
        <meta property="og:url" content="https://katbot.ai/" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "Katbot",
          "url": "https://katbot.ai",
          "applicationCategory": "FinanceApplication",
          "operatingSystem": "Web",
          "description": "AI-powered trading intelligence platform for leveraged perpetuals on Hyperliquid. Agentic AI agents that find trades, manage risk, and execute automatically.",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD",
            "description": "Free during Early Access"
          },
          "creator": {
            "@type": "Organization",
            "name": "Katbot",
            "url": "https://katbot.ai",
            "sameAs": [
              "https://discord.gg/asTcxUTzRv",
              "https://github.com/claytantor/katbotai-openclaw"
            ]
          }
        })}</script>
      </Helmet>
      <div className="mx-auto w-full px-0 flex flex-col items-start justify-start">
        <Hero config={config} />
        <AgenticWorkflow />
        <CapabilitiesGrid />
        <FeaturedIntegrations config={config} />
        {/* <StatsBar /> */}
        <FinalCTA />
      </div>
    </div>
  );
};
